import { render, staticRenderFns } from "./kasaOzeti.vue?vue&type=template&id=7a6479b1&scoped=true&"
import script from "./kasaOzeti.vue?vue&type=script&lang=js&"
export * from "./kasaOzeti.vue?vue&type=script&lang=js&"
import style0 from "./kasaOzeti.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./kasaOzeti.vue?vue&type=style&index=1&id=7a6479b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6479b1",
  null
  
)

export default component.exports